<template>
  <v-list-item class="ma-0" @click="doRobsThing" title="Altametrics" v-if="isDev">
    <template v-slot:prepend>
      <div style="height: 26px; width: 26px" class="mr-4">
      <v-progress-circular
        v-if="loading"
        :size="25"
        indeterminate
        class="mr-4"
      />
      <altalogo v-else />
      </div>
    </template>
  </v-list-item>
</template>
<script setup>
import { ref } from 'vue';
import altalogo from './altalogo.vue';
import { Auth } from 'aws-amplify';

const loading = ref(false);
const isDev = window.location.host === 'dev-v3.myqsrsoft.com' || window.location.host === 'dev-home.myqsrsoft.com';

async function getToken() {
  const currentSession = await Auth.currentSession();
  const { idToken } = currentSession;
  return idToken.jwtToken;
}
const baseURL = import.meta.env.VITE_APP_SSO_API_BASE_URL;
// hit https://api.dev.myqsrsoft.com/token/zendesk?alta=true
async function doRobsThing() {
  loading.value = true;
  try {
    const token = await getToken();
    const response = await fetch(`${baseURL}/token/zendesk?alta=true`, {
      method: 'GET',
      headers: {
        'x-auth-token': token,
      },
    });
    const data = await response.json();
    loginWithJWT(data.token);
  } catch (error) {
    console.error('Error fetching Altametrics token:', error);
  } finally {
    loading.value = false;
  }
}

function postAndNavigate(url) {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = url;

  document.body.appendChild(form);
  form.submit();
}

function loginWithJWT(jwt) {
  const url =
    'https://devsso.mcdaltametrics.com/aim/login/QSRResponseController/APP_QA_TEST?jwt=' +
    encodeURIComponent(jwt);
  postAndNavigate(url);
}
</script>
